import { CheckCircle2, Clock, Send } from "lucide-react";

export function StatusBadge({ status, testId }) {
  if (status === "order")
    return (
      <span data-testid={testId} className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold bg-sky-50 text-sky-700 border border-sky-200 whitespace-nowrap">
        <Send className="h-3.5 w-3.5" /> Order Baru
      </span>
    );
  if (status === "paid")
    return (
      <span data-testid={testId} className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold bg-emerald-50 text-emerald-700 border border-emerald-200 whitespace-nowrap">
        <CheckCircle2 className="h-3.5 w-3.5" /> Lunas
      </span>
    );
  return (
    <span data-testid={testId} className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold bg-amber-50 text-amber-700 border border-amber-200 whitespace-nowrap">
      <Clock className="h-3.5 w-3.5" /> Belum Dibayar
    </span>
  );
}

export function StatCard({ label, value, hint, tone = "light", testId, delay = 0 }) {
  const dark = tone === "dark";
  return (
    <div
      className={`rise relative overflow-hidden rounded-2xl p-5 border ${dark ? "grain bg-slate-950 text-white border-slate-900" : "bg-white border-slate-200"}`}
      style={{ animationDelay: `${delay}ms` }}
    >
      <p className={`text-[11px] font-semibold uppercase tracking-[0.15em] ${dark ? "text-emerald-400" : "text-slate-400"}`}>{label}</p>
      <p data-testid={testId} className={`font-num font-bold mt-2 text-xl sm:text-2xl tracking-tight ${dark ? "text-white" : "text-slate-900"}`}>{value}</p>
      {hint && <p className={`text-xs mt-1 ${dark ? "text-slate-400" : "text-slate-500"}`}>{hint}</p>}
    </div>
  );
}

export function PageHeader({ eyebrow, title, children }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8 rise">
      <div>
        {eyebrow && <p className="text-xs font-semibold uppercase tracking-[0.2em] text-emerald-600">{eyebrow}</p>}
        <h1 className="font-heading text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900 mt-1" data-testid="page-title">{title}</h1>
      </div>
      {children && <div className="flex flex-wrap items-end gap-2">{children}</div>}
    </div>
  );
}

export function MonthFilter({ value, onChange, testId = "month-filter" }) {
  return (
    <label className="flex flex-col gap-1">
      <span className="text-[11px] font-semibold uppercase tracking-wider text-slate-400">Bulan Report</span>
      <div className="flex gap-1">
        <input
          type="month"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="h-10 rounded-lg border border-slate-200 bg-white px-3 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500/30"
          data-testid={testId}
        />
        {value && (
          <button onClick={() => onChange("")} className="h-10 px-3 rounded-lg text-xs font-semibold text-slate-500 hover:bg-slate-100" data-testid={`${testId}-clear`}>
            Semua
          </button>
        )}
      </div>
    </label>
  );
}

export function EmptyState({ title, text, testId }) {
  return (
    <div className="rounded-2xl border border-dashed border-slate-300 bg-white p-10 text-center" data-testid={testId}>
      <p className="font-heading font-semibold text-slate-800">{title}</p>
      <p className="text-sm text-slate-500 mt-1">{text}</p>
    </div>
  );
}
